/**
 * Resolve a backend media path (under wwwroot/uploads) to an absolute URL.
 */
export function resolveMediaUrl(path) {
  if (!path) return '';
  if (typeof path === 'string' && path.startsWith('http')) return path;
  const base =
    process.env.REACT_APP_MEDIA_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    '';
  const normalizedPath = String(path).startsWith('/') ? path : `/${path}`;
  return `${base.replace(/\/$/, '')}${normalizedPath}`;
}

/**
 * Turns pasted absolute media URLs into a path like `/uploads/...` for API bodies.
 * Relative paths are left normalized with a leading slash when needed.
 */
export function normalizeMediaPathForStorage(input) {
  if (input == null) return '';
  const s = String(input).trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) {
    const bases = [
      process.env.REACT_APP_MEDIA_BASE_URL,
      process.env.REACT_APP_API_BASE_URL,
    ].filter(Boolean);
    for (const b of bases) {
      const base = String(b).replace(/\/$/, '');
      if (s.startsWith(base)) {
        const rest = s.slice(base.length);
        return rest.startsWith('/') ? rest : `/${rest}`;
      }
    }
    try {
      return new URL(s).pathname || '/';
    } catch {
      return s;
    }
  }
  return s.startsWith('/') ? s : `/${s}`;
}
